var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',[_c('v-text-field',{attrs:{"outlined":"","label":_vm.$t('Schreiben Sie hier Ihre Anwort'),"hide-details":""},model:{value:(_vm.computedAnswer),callback:function ($$v) {_vm.computedAnswer=$$v},expression:"computedAnswer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }